import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _11mpIcon(props: IconProps) {
    return <Icon {...props} iconKey={"11mp"}/>
}
